import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {map} from 'rxjs/operators';
import {ElementGroupFormService} from '../../element-group-form/element-group-form.service';
import {FormHelperService} from '@services/form-helper.service';
import {EventsService} from '@services/events.service';

@Component({
    selector: 'app-methods-subform',
    templateUrl: './methods-subform.component.html',
})
export class MethodsSubformComponent implements OnInit, OnDestroy {

    @Input() fbArray: FormArray;
    methods: SelectValueInterface[] = [];

    public disabled = false;

    constructor(
        private fb: FormBuilder,
        private helperService: ElementGroupFormService,
        private eventsService: EventsService,
    ) {

    }

    ngOnInit() {
        this.disabled = this.fbArray.disabled;

        this.helperService.methodsList$.pipe(
            untilDestroyed(this),
        ).subscribe((methods) => {
            this.methods = methods;
            this.softReset();

            if (this.disabled) {
                this.fbArray.disable();
            }
        });

        /**
         * При смене
         */
        this.fbArray.valueChanges.pipe(
            map((values) => values.map(v => Number(v.industry_method_id)).filter(v => Boolean(v))),
            map((selectedIds: number[]): SelectValueInterface[] => this.methods.map(m => {
                return {
                    ...m,
                    disabled: selectedIds.includes(Number(m.id)),
                };
            })),
            untilDestroyed(this),
        ).subscribe((methods: SelectValueInterface[]) => {
            this.methods = methods;
        });

        if (!this.fbArray.length) {
            this.addMethod();
        }
    }

    addMethod(methodId: string|number = '', amount_of_work = 100, id = null) {
        const group = this.fb.group({
            id: [id],
            industry_method_id: [methodId],
            amount_of_work: [amount_of_work]
        });

        group.get('amount_of_work').disable();

        this.fbArray.push(group);
    }

    removeMethod(index: number) {
        const group: FormGroup = this.fbArray.at(index) as FormGroup;

        const id = group.value.id;

        if (id) {
            this.eventsService.showConfirm({
                title: 'Вы уверены, что хотите удалить метод?',
                message: 'При сохранении формы будут удалены все техкарты и заключения данного типоразмера по данному методу. ' +
                    'Отменить действие после сохранения формы будет невозможно.',
                confirmButtonTitle: 'Удалить'
            }).subscribe(() => {
                this.fbArray.removeAt(index);

            }, () => {});
        } else {
            this.fbArray.removeAt(index);
        }
    }

    /**
     * Производим сброс полей, оставляя все доступные для выбора и выбранные ранее значения или пустой селект, если нужно
     */
    private softReset() {
        const methodsIds = this.methods.map(m => m.id);
        const currentValue = this.fbArray.value;
        FormHelperService.clearArray(this.fbArray);

        /**
         * Восстанавливаем все выбранные ранее значения, если они доступны для выбора
         */
        currentValue.forEach(v => {
            if (v && v.industry_method_id && methodsIds.includes(Number(v.industry_method_id))) {
                this.addMethod(v.industry_method_id, v.amount_of_work || 100, v.id || null);
            }
        });

        /**
         * Если значений нет, добавляем одно пустое для выбора
         */
        if (!this.fbArray.length) {
            this.addMethod();
        }
    }

    ngOnDestroy(): void {

    }
}
